import { inject, Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageNavigationService } from './services/message-navigation.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly injector = inject(Injector);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 409 && error.error?.type === 'notActiveError') {
          this.injector.get(MessageNavigationService).goToMessage('account_not_active_error');
        }
        
        return throwError(() => error);
      })
    );
  }
}
